import React, { useState } from 'react';
import HeroNew from '../components/HeroNew';
import WhatsAppButton from '../components/WhatsAppButton';
import FormularioModal from '../components/FormularioModal';
import IncludedBenefits from '../components/IncludedBenefits';
import WhyChooseUs from '../components/WhyChooseUs';
import Testimonials from '../components/Testimonials';
import GroupSafetyBanner from '../components/GroupSafetyBanner';
import PousadaSection from '../components/PousadaSection';
import PaymentSection from '../components/PaymentSection';
import PortoSeguroPackages from '../components/PortoSeguroPackages';
import BusSection from '../components/BusSection';
import VideoGallery from '../components/VideoGallery';
import AerialPackages from '../components/AerialPackages';
import FinalCTA from '../components/FinalCTA';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';
import { Toaster } from '../components/ui/sonner';

const Home = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const handleOpenForm = () => {
    setIsFormOpen(true);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* 1. Cabeçalho (Hero) */}
      <HeroNew onOpenForm={handleOpenForm} />
      
      <WhatsAppButton onOpenForm={handleOpenForm} />
      <FormularioModal isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} />
      
      {/* 2. O que está incluso no pacote */}
      <IncludedBenefits />
      
      {/* 3. Por que escolher A.R. Turismo */}
      <WhyChooseUs />
      
      {/* 4. Depoimentos */}
      <Testimonials />
      
      {/* 5. Viaje em Grupo com Total Segurança */}
      <GroupSafetyBanner onOpenForm={handleOpenForm} />
      
      {/* 6. Pousada Verdes Mares */}
      <PousadaSection onOpenForm={handleOpenForm} />
      
      {/* 7. Pagamento Facilitado */}
      <PaymentSection onOpenForm={handleOpenForm} />
      
      {/* 8. Experiência em Porto Seguro */}
      <PortoSeguroPackages onOpenForm={handleOpenForm} />
      
      {/* Outros blocos */}
      <BusSection />
      <VideoGallery />
      <AerialPackages onOpenForm={handleOpenForm} />
      <FinalCTA onOpenForm={handleOpenForm} />
      <FAQ onOpenForm={handleOpenForm} />
      <Footer onOpenForm={handleOpenForm} />
      <Toaster />
    </div>
  );
};

export default Home;
